//original jquery

//css切り替え
$(function(){
  $("#CCCButton").on("click", function(){
     $("#search-product-grid, #product-grid").toggleClass("on");
  });
});

//button icon切り替え
$(document).ready(function() {
    $('#CCCButton').click(function() {
        if ($('.grid-icon-container .active-grid-icon').attr('id') === 'icon-grid-square-3x3') {
            $('#icon-grid-square-3x3').removeClass('active-grid-icon').addClass('hidden-grid-icon');
            $('#icon-grid-square').removeClass('hidden-grid-icon').addClass('active-grid-icon');
        } else {
            $('#icon-grid-square-3x3').removeClass('hidden-grid-icon').addClass('active-grid-icon');
            $('#icon-grid-square').removeClass('active-grid-icon').addClass('hidden-grid-icon');
        }
    });
});